module.exports = __webpack_public_path__ + "img/HP_00_mono_AE_00004.1dfd0b50.png";